import "./../CashForDeed.css";

const CfdPropertyValueInfo = ({ item, activeTab }) => {
  const isSavedTab = activeTab === "saved";

  // Extract values properly
  const listingPrice = isSavedTab
    ? item?.propertyListingDetails?.listPrice
    : item?.listingPrice;

  const estimatedValue = isSavedTab
    ? item?.propertyDetails?.estimatedPropertyValue
    : item?.estimatedPropertyValue;

  const startingAmount = isSavedTab ? item?.cfdMinOffer : item?.startingBid;

  const currentBid = isSavedTab ? item?.currentBid : item?.currentBid;

  // Function to determine if a value should be displayed
  const shouldDisplay = (value) =>
    value !== undefined && value !== null && value !== "";

  return (
    <div className="cfd-property-values-wrapper">
      {shouldDisplay(listingPrice) && (
        <div className="cfd-value-box">
          <div className="cfd-value-label">List Price:</div>
          <div className="cfd-value-amount">
            ${listingPrice.toLocaleString()}
          </div>
        </div>
      )}

      {!shouldDisplay(listingPrice) && shouldDisplay(estimatedValue) && (
        <div className="cfd-value-box">
          <div className="cfd-value-label">Estimated Property Value:</div>
          <div className="cfd-value-amount">
            ${estimatedValue.toLocaleString()}
          </div>
        </div>
      )}

      {!currentBid && shouldDisplay(startingAmount) && (
        <div className="cfd-value-box">
          <div className="cfd-value-label">Starting Offer Amount:</div>
          <div className="cfd-value-amount cfd-fw">
            ${startingAmount.toLocaleString()}
          </div>
        </div>
      )}
    </div>
  );
};

export default CfdPropertyValueInfo;
